import { RouteRecordRaw } from 'vue-router';

import { $i } from '@silae/composables';
import { defaultLayoutComponents } from '~/_v3/common/ui/components/layout/layout';
import { RouteKeys } from '~/router/routes.domain';

export const HomeRoute: RouteRecordRaw = {
	name: RouteKeys.HOME,
	path: '/home',
	alias: '',
	components: {
		default: () => import('~/_v3/home/ui/pages/HomePage.vue'),
		...defaultLayoutComponents
	},
	meta: {
		label: 'home.navigation',
		icon: () => $i('dashboard'),
		isNavEntry: true,
		order: 1,
		requiresAuth: true
	}
};
